/* BLK_STICKY_ATC_FLOATING_WIDGET_OFFSET_START - Keep mobile contact launchers above the sticky add-to-cart bar. */
(function () {
  if (window.__BLK_STICKY_ATC_FLOATING_WIDGET_OFFSET__ === '20260826-v1') return;
  window.__BLK_STICKY_ATC_FLOATING_WIDGET_OFFSET__ = '20260826-v1';

  var CHAT_SELECTOR = 'shopify-chat, #ShopifyChat, inbox-online-store-chat#ShopifyChat, inbox-online-store-chat';
  var ALOVE_SELECTOR = '.tkf-alove-float';
  var BAR_SELECTOR = [
    '[data-blk-sticky-atc].is-visible',
    '[id^="StickyATC-"].sticky-atc.is-visible',
    '.sticky-atc.sticky-atc--v2.is-visible'
  ].join(', ');
  var MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  var GAP = 16;
  var scheduled = false;
  var lastTrackedSignature = '';
  var barWasVisible = false;
  var settleTimer = 0;

  function rectOf(element) {
    return element ? element.getBoundingClientRect() : null;
  }

  function visible(element) {
    if (!element) return false;
    var rect = rectOf(element);
    var style = window.getComputedStyle(element);
    return style.display !== 'none'
      && style.visibility !== 'hidden'
      && Number(style.opacity || 1) > 0.05
      && rect.width > 0
      && rect.height > 0;
  }

  function getBar() {
    var bars = Array.prototype.filter.call(document.querySelectorAll(BAR_SELECTOR), function (bar) {
      if (!visible(bar)) return false;
      var rect = rectOf(bar);
      return rect.height >= 60
        && rect.bottom >= window.innerHeight - 8
        && rect.top > window.innerHeight * 0.45;
    });

    return bars.sort(function (a, b) {
      return rectOf(b).height - rectOf(a).height;
    })[0] || null;
  }

  function setPropertyIfChanged(element, property, value) {
    if (!element || element.style.getPropertyValue(property) === value) return;
    element.style.setProperty(property, value, 'important');
  }

  function clearProperty(element, property) {
    if (element && element.style.getPropertyValue(property)) {
      element.style.removeProperty(property);
    }
  }

  function clearOffsets(state) {
    var alove = document.querySelector(ALOVE_SELECTOR);
    var chat = document.querySelector(CHAT_SELECTOR);

    clearProperty(alove, '--tkf-alove-sticky-atc-shift');
    clearProperty(chat, '--shopify-agent-activator-offset');

    if (alove) alove.setAttribute('data-blk-sticky-atc-widget-state', state);
    if (chat) chat.setAttribute('data-blk-sticky-atc-widget-state', state);
  }

  function moveAloveAboveBar(alove, barRect) {
    if (!alove || !visible(alove)) return 0;

    var aloveRect = rectOf(alove);
    var currentBottom = Math.max(0, window.innerHeight - aloveRect.bottom);
    var currentShift = Number.parseFloat(window.getComputedStyle(alove).getPropertyValue('--tkf-alove-sticky-atc-shift')) || 0;
    var baseBottom = Math.max(0, currentBottom - currentShift);
    var requiredBottom = Math.max(0, window.innerHeight - barRect.top + GAP);
    var shift = Math.max(0, Math.round(requiredBottom - baseBottom));

    setPropertyIfChanged(alove, '--tkf-alove-sticky-atc-shift', String(shift) + 'px');
    alove.setAttribute('data-blk-sticky-atc-widget-state', 'shifted');
    return shift;
  }

  function moveChatAboveBar(chat, barRect) {
    if (!chat) return 0;

    var requiredBottom = Math.max(0, Math.round(window.innerHeight - barRect.top + GAP));
    setPropertyIfChanged(chat, '--shopify-agent-activator-offset', String(requiredBottom) + 'px');
    chat.setAttribute('data-blk-sticky-atc-widget-state', 'shifted');
    return requiredBottom;
  }

  function track(aloveShift, chatOffset, barHeight) {
    var signature = [aloveShift, chatOffset, barHeight].join(':');
    if (signature === lastTrackedSignature) return;

    lastTrackedSignature = signature;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'blk_sticky_atc_floating_widgets_offset_applied',
      component: 'mobile_floating_widgets',
      reason: 'sticky_atc_visible',
      alove_shift_px: aloveShift,
      shopify_chat_bottom_offset_px: chatOffset,
      bar_height_px: barHeight
    });
  }

  function scheduleAfterBarSettles() {
    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(schedule, 360);
  }

  function update() {
    scheduled = false;

    if (!MOBILE_QUERY.matches) {
      barWasVisible = false;
      clearOffsets('desktop');
      return;
    }

    var bar = getBar();
    if (!bar) {
      barWasVisible = false;
      window.clearTimeout(settleTimer);
      clearOffsets('idle');
      return;
    }

    if (!barWasVisible) {
      barWasVisible = true;
      scheduleAfterBarSettles();
    }

    var barRect = rectOf(bar);
    var aloveShift = moveAloveAboveBar(document.querySelector(ALOVE_SELECTOR), barRect);
    var chatOffset = moveChatAboveBar(document.querySelector(CHAT_SELECTOR), barRect);
    track(aloveShift, chatOffset, Math.round(barRect.height));
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }

  ['DOMContentLoaded', 'load', 'resize', 'scroll', 'orientationchange'].forEach(function (name) {
    window.addEventListener(name, schedule, { passive: true });
  });

  MOBILE_QUERY.addEventListener('change', schedule);

  if (document.documentElement) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
  }

  schedule();
  window.setTimeout(schedule, 500);
  window.setTimeout(schedule, 1500);
  window.setTimeout(schedule, 3000);
})();
/* BLK_STICKY_ATC_FLOATING_WIDGET_OFFSET_END */